export const home_page_events = {
  home_zenvoya_logo_click: {
    category: "User clicks on zenvoya logo to navigate to the home page",
    action: "On any page user can click on Zenvoya logo",
    label: "sidebar-logo-click",
  },
  chat_input_field_send_prompt_to_llm_click: {
    category: "User sends search prompt",
    action: "User clicks on prompt send button",
    label: "home-chat-send",
  },
    home_four_trip_suggestions_generated: {
    category: "Home",
    action: "Four trip suggestions generated on home page",
    label: "home-four-trip-suggestions-generated",
  },

  home_chat_input_click: {
    category: "User clicks on input field",
    action: "User clicks on input field to type the prompt",
    label: "home-chat-input",
  },
  home_suggestion_click: {
    category: "Home",
    action: "User clicks a suggestion chip under the latest assistant turn",
    label: "home-suggestion-click",
  },
  chat_input_field_cancel_generating_llm_response: {
    category: "User stops the prompt request",
    action: "User clicks on stop button",
    label: "home-chat-input-stop-click",
  },
  chat_input_field_start_mic_record: {
    category: "User record the prompt by using voice recording",
    action: "User clicks on mic button",
    label: "home-chat-mic-record-click",
  },

  chat_input_field_mic_stop_recording_click: {
    category: "User can stop the voice recording",
    action: "User clicks on mic button to stop recording",
    label: "home-chat-mic-stop-record-click",
  },

  home_tile: {
    category: "Pill prompt",
    action: "User click on one of the pill prompt",
    label: "home-chat-tile",
  },
  home_chat_tile_explore_places: {
    category: "Pill prompt",
    action: "User clicks the 'Explore places' suggestion tile on the welcome screen",
    label: "home-chat-tile-explore-places",
  },
  start_chat: {
    category: "Chat Interaction",
    action: "User interacting with chat",
    label: "start-chat",
  },
  startChat: {
    category: "Chat Interaction",
    action: "User interacting with chat",
    label: "startChat",
  },
  appLoaded: {
    category: "Application Loaded",
    action: "When the application is loaded",
    label: "appLoaded",
  },
  signUp: {
    category: "User Sign Up",
    action: "When the user signs up",
    label: "signUp",
  },
  interactedWithChat: {
    category: "User Interaction with Chat",
    action: "User interacted with chat on home page",
    label: "interactedWithChat",
  },
  onboarding_itinerary_creation_auto: {
    category: "Onboarding Itinerary Creation",
    action: "Automatic itinerary creation during onboarding",
    label: "onboarding_itinerary_creation_auto",
  },
   home_chat_try_again_click: {
    category: "Chat Interuption",
    action: "User clicked on home chat try again",
    label: "home-chat-try-again-click",
  },
};
